export default "__VITE_ASSET__BkJvhfQm__"